import React from 'react'
import { Typography } from '@material-ui/core'
import { Panel } from '../common/Layout'
import PanelHeader from '../common/PanelHeader'
import cuisineTypeOptions from '../../util/cuisineTypeOptions'
import CuisinePreference from './CuisinePreference'

export const PanelCuisinePreferences = ({
  updateProfileAttributesStart,
  isUpdatingCuisinePreference,
  isLoadingCuisinePreference,
  additionalAttributes = [],
  errorSettingCuisinePreferences,
  errorUpdatingCuisinePreferences,
}) => {
  return (
    <Panel>
      <PanelHeader title="Favorite Cuisines" />
      <CuisinePreference
        isUpdatingCuisinePreference={isUpdatingCuisinePreference}
        isLoadingCuisinePreference={isLoadingCuisinePreference}
        cuisineType={cuisineTypeOptions}
        additionalAttributes={additionalAttributes}
        updateProfileAttributesStart={updateProfileAttributesStart}
        errorSettingCuisinePreferences={errorSettingCuisinePreferences}
        errorUpdatingCuisinePreferences={errorUpdatingCuisinePreferences}
      />
      {(errorUpdatingCuisinePreferences || errorSettingCuisinePreferences) && (
        <Typography color="error">
          Oops! Something went wrong. If this continues to happen, please contact support.
        </Typography>
      )}
    </Panel>
  )
}

export default PanelCuisinePreferences
